import React from 'react'

const Consultancy = () => {
  return (
    <>
 
      <div>
      <div className="research-head">ONGOING CONSULTING PROJECTS</div>
      <div className="consulting">   
       <div class="ss">
       <br /><span>&#8226; Investigations of core-shell nanostructures for photocatalytic hydrogen evolution</span> 	
      
       <br /><span>&#8226; Porous MOF mobilized chalcogenides photoelectrodes for sustainable and clean solar-driven hydrogen fuel generation</span> 
        <br /><span>&#8226; MOFs derived nanoporous materials for fabrication of high-performance energy storage devices</span> 
        <br /><span>&#8226; Textile electrodes coated with agri/bio-waste derived activated carbon for supercapacitors</span> 
        <br /><span>&#8226; Exploration of Ni-Co-V ternary system based on deformation mechanisms</span>
        
        <br /><span>&#8226; 	Development of Adhesives using Silicone, Conducting Polymers and Nanomaterials for elevated Temperature Application</span>
        <br /><span>&#8226; 	Investigation of traditional iron monuments in the central India and understanding their metallurgical origins</span>
        <br /><span>&#8226; Development of economic super-absorbent Agri-gel for studying and soil, water and nutrient retention properties</span>
        <br /><span>&#8226; 	Multifractal structural engineering of MOF derived materials for the electrode of hybrid supercapacitors</span>
        <br /><span>&#8226; DST-IISER Thiruvananthapuram Integrated Clean Energy Material Acceleration Platform on Storage</span>
        
        
        
        
        
        <br /><span>&#8226; 	Polymer-Ceramic Composite Electrolytes for Rechargeable Lithium Metal Batteries</span>
        <br /><span>&#8226; 	Development of All Earth Abundant Elements based Nano-heterostructures for Solar Driven Water Splitting</span>
        <br /><span>&#8226; 	Development of Microstructure- Property-Processing Correlations for nickel-based superalloys</span>
        <br /><span>&#8226; 		Development of Fe-based composite materials mimicking Delhi iron pillar’s structure</span>
        <br /><span>&#8226; Development of Super-absorbent hydrogel for agriculture applications</span>
        
        
        
        
        <br /><span>&#8226; 	Development of conducting polymer scaffolded ABO3 nanofibers for solar supercapacitor application</span>
        <br /><span>&#8226; 	Development of multifunctional 2D materials for energy applications</span>
        <br /><span>&#8226; 	DEVELOPMENT OF OXIDE DISPERSION STRENGTHENED-TUNGSTEN HEAVY ALLOYS (ODS-WHAS) FOR DEFENSE APPLICATION</span>
        
        <br /><span>&#8226; Sustainable, Engineered Sodium-ion Batteries for Renewable Energy Storage</span>
        
        
        
        <br /><span>&#8226; 	Design and development of equiatomic multicomponent FeCoNiAx A Nil, Al, Ti, Cr, Si alloys for electromagnetic applications</span>
        <br /><span>&#8226; 	Waste characterization and possible gainful utilization of induction melting furnace dust</span>
        <br /><span>&#8226; 	Fabrication of lead free perovskite solar cells based on metal oxide nanoarchitectures and Sprio-OMeTAD</span>
        <br /><span>&#8226;Development and Characterization of novel Vajra Lep Coating</span> 
        <br /><span>&#8226; Development of novel eutectic high entropy alloys for high temperature applications</span>
        
        <br /><span>&#8226; 	Design and manufacturing of miniature Kolsky bar or Split Hopkinson Pressure Bar(SHPB)</span>
        <br /><span>&#8226;Development of Light Weight Eutectic High Entropy Alloys ( LWEHEAs)</span> 
        <br /><span>&#8226; 	Nano-hetero-architectures of mesoporous ABO3 compounds for photocatalytic applications.</span>
        
        
        
        
        </div>
        </div>

      
      </div>
     
    </>
  
    
  )
}

export default Consultancy
